import React, { useState, useEffect } from 'react';
import { API_DOMAIN } from './globals'; // Import the global domain name

function MyLedger() {

    const [myLedger, setMyLedger] = useState([]);
    const [totalDebit, setTotalDebit] = useState(0);
    const [totalCredit, setTotalCredit] = useState(0);
    const [balance, setBalance] = useState(0);

    function calculateBalance(Ledger) {
        let bal = 0;

        const updatedLedger = Ledger.map((entry) => {
            bal -= parseFloat(entry.Credit);
            bal += parseFloat(entry.Debit);
            return { ...entry, Balance: parseFloat(bal).toFixed(2) };
        });
        
        //console.log(updatedLedger);
        setMyLedger(updatedLedger);
    };

    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    useEffect(() => {
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        const params = { ut: param1, un: param2 };

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getMyLedger.php?${queryString}`;
        
        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if(data.Status=="Error") {
                    sessionStorage.setItem("LogoutMsg",data.Message)
                    window.location = '/';
                } else {
                    //console.log(data.data);
                    //setMyLedger(data.data); // Save the response data in state

                    const ledgerData = data.data;
                    setMyLedger(ledgerData);

                    if (ledgerData.length > 0) {
                        setTotalDebit(ledgerData[0].TotDebit);
                        setTotalCredit(ledgerData[0].TotCredit);
                        setBalance(-ledgerData[0].Balance);
                        //console.log("TotDebit="+ledgerData[0].TotDebit+", TotCredit="+ledgerData[0].TotCredit+", Balance="+ledgerData[0].Balance)
                        calculateBalance(ledgerData);
                    }
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });

    }, []);  // Empty dependency array ensures this runs only once when the component mounts

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <section className="accountste match-content">
                <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white'}}>My Ledger</div>
                <div className="col-md-12"></div>
                <div id="divLoading"></div>
                <div className="appendAjaxTbl">
                    <div className="table-responsive sports-tabel">
                        <table className="table table-bordered table-hover" id="datatabless">
                            <thead>
                                <tr style={{ background: '#000',color:'white'}}>
                                    <th>S.No.</th>
                                    <th>Description</th>
                                    <th className="rrig text-left">WON BY</th>
                                    <th className="rrig text-left">WON</th>
                                    <th className="rrig text-left">LOST</th>
                                    <th className="rrig text-left">HISAB</th>
                                </tr>
                            </thead>
                            <tbody>
                                {myLedger.map((row, index) => (
                                    <tr key={index}>
                                        <td style={{color:'black'}}>{index + 1}</td>
                                        <td style={{color:'black'}}>
                                            <a href={row.URL}>
                                                {row.SportName === "Cricket" && row.Result ? row.Result : row.Remark}{" "}
                                                (<span>{new Date(row.DateTime).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" })}</span>)
                                            </a>
                                        </td>
                                        <td className="text-left" style={{color:'black'}}>{row.WonBy}</td>
                                        <td className="text-left" style={{color: row.Debit > 0 ? 'green' : row.Debit < 0 ? 'red' : 'black',fontWeight:'bold'}}>{row.Debit}</td>
                                        <td className="text-left" style={{color: row.Credit > 0 ? 'red' : row.Credit < 0 ? 'green' : 'black',fontWeight:'bold'}}>{row.Credit}</td>
                                        <td className="text-left" style={{color: row.Balance > 0 ? 'green' : row.Balance < 0 ? 'red' : 'black',fontWeight:'bold'}}>{row.Balance}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MyLedger;
